import { Col, Form, Input, Row } from 'antd';

import { useIntl } from 'react-intl';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import AppPageHeader from '@/components/_common/AppPageHeader';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import { ListDocumentTypesQuery } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.types';

const DocumentTypesSelectedFilters: React.FC<
  ExtraFiltersProps<ListDocumentTypesQuery>
> = ({ setQueryParams }) => {
  const intl = useIntl();

  return (
    <AppPageHeader
      onSearch={(value: string) =>
        setQueryParams((prev) => ({ ...prev, description: value }))
      }
      extraFilters={
        <Form>
          <Row gutter={8}>
            <Col span={12}>
              <Input
                name="initials"
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({ ...prev, initials: value }))
                }
                placeholder={intl.formatMessage({
                  id: 'documentTypes.list.header.initials',
                })}
              />
            </Col>

            <Col span={12}>
              <OrderExtraFilter
                onChange={(value) =>
                  setQueryParams((prev) => ({
                    ...prev,

                    order: value,
                  }))
                }
              />
            </Col>
          </Row>
        </Form>
      }
    />
  );
};

export default DocumentTypesSelectedFilters;
